import { gql } from '@apollo/client';

export const getWebCalculationsSupplementary = gql`
  query Health($birthDate: String!) {
    health {
      webCalculationsSupplementary(birthDate: $birthDate) {
        productCode
        productLabel
        brandName
        actionLabel
        price {
          totalOneTimePayment
          totalWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
        logo
      }
    }
  }
`;
